import React, {useEffect, useState} from "react";
import {Company, CompanyAPI} from "../../api/company/CompanyAPI";
import PageHeader from "../../components/layout/PageHeader";
import PageContent from "../../components/layout/PageContent";
import {DataTable, DataTableColumn, useDataTableColumns} from "mantine-datatable";
import Cell from "../../components/table/Cell";
import {useContextMenu} from "mantine-contextmenu";
import {IconEye, IconTrash} from "@tabler/icons-react";
import {notifications} from "@mantine/notifications";
import {CompanyPageMenu} from "./CompanyPageMenu";
import CreateCompanyModal from "./CreateCompanyModal";
import { UpdateCompanyModal } from "./UpdateCompanyModal";

const key = "company-table-key";

const columns: DataTableColumn<Company>[] = [
    {
        title: '#',
        accessor: 'id',
        toggleable: true,
        defaultToggle: false,
        sortable: true
    },

    {
        title: 'Nazwa',
        accessor: 'title',
        toggleable: false,
        render: (record) => <Cell orOptional={record.title} />,
        sortable: true
    }
];

export const CompanyPage = () => {
  const { showContextMenu } = useContextMenu();
  const [isFetching, setFetching] = useState(false);
  const [data, setData] = useState<Company[]>();
  const [selectedRecords, setSelectedRecords] = useState<Company[]>([]);
  const [isCreateModal, setCreateModal] = useState(false);
  const [editCompany, setEditCompany] = useState<Company>();

  const { effectiveColumns } = useDataTableColumns({
    key, columns
  });

  const reload = () => {
    setFetching(true);
    CompanyAPI.listAsync()
      .then(setData)
      .catch(() => notifications.show({
        title: 'Wystąpił błąd...',
        message: 'Wystąpił błąd podczas ładowania, jeśli uważasz, że to pomyłka proszę skontaktować się z administratorem.',
        color: 'red'
      }))
      .finally(() => setFetching(false));
  }

  const onRowContextMenu = (data: {record: Company, event: any}) => {
    showContextMenu([
      {
        key: 'edit-company',
        title: 'Edytuj',
        icon: <IconEye size={16}/>,
        onClick: () => {
          setEditCompany(data.record);
        }
      },
      {
        key: 'delete-company',
        title: 'Usuń',
        color: 'red',
        icon: <IconTrash size={16}/>,
        onClick: () => {}
      }
    ])(data.event);
  }

  useEffect(reload, []);

  return (
    <>
      <PageHeader
        title="Firmy"
        pageTitle="Firmy"
        url="/company"
        action={
          <CompanyPageMenu
            create={() => { setCreateModal(true); }}
          />
        }
      />

      <PageContent>
        <DataTable
          height="60vh"
          withColumnBorders
          styles={{ header: { background: 'white' } }}
          storeColumnsKey={key}
          minHeight="150px"
          fetching={isFetching}
          highlightOnHover
          columns={effectiveColumns}
          style={{marginBottom: '50px'}}
          backgroundColor={'transparent'}
          noRecordsText={"Pusto..."}
          loaderBackgroundBlur={1}
          records={data ?? []}
          selectedRecords={selectedRecords}
          onSelectedRecordsChange={setSelectedRecords}
          onRowContextMenu={onRowContextMenu}
        />
      </PageContent>

      <UpdateCompanyModal
        company={editCompany}
        closeAndUpdate={() => {
          setEditCompany(undefined);
          reload();
        }}
        justClose={() => {
          setEditCompany(undefined);
        }}
      />

      <CreateCompanyModal
        isOpen={isCreateModal}
        justClose={() => {
          setCreateModal(false);
        }}
        closeAndUpdate={() => {
          setCreateModal(false);
          reload();
        }}
      />
    </>
  )
}